import { render, staticRenderFns } from "./Discard.vue?vue&type=template&id=69f657b7&"
import script from "./Discard.vue?vue&type=script&lang=js&"
export * from "./Discard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports